module.exports = __webpack_public_path__ + "static/media/patrol(11).254eaad0.PNG";